import { buildUibComponentModal, defineThisScopeBinding, elementToModalRef } from "../../../ajs/ajs-migration-utils.js";
import { ContentCatalog, ContentCatalogClientOeuvreItem } from "../content-catalog.js";

export class CatalogEditorModalComponent {

    static selector = "modal-catalog-editor";
    static template = `
        <a class="close-btn" href="javascript:void(0)" ng-click="close()"></a>

		<style type="text/css">
			@media (max-width: 992px) {
				body.modal-open > .modal > .modal-dialog.modal-lg {
					width: calc( 100% - 60px );
				} 
			}
		</style>

        <div class="modal-header">
            <h3 class="modal-title">
                <button class="btn btn-sm btn-default" ng-click="goToCatalogViewer()"><b class="glyphicon glyphicon-chevron-left"></b>&nbsp;{{ 'Content catalogs' | translate }}</button>

                <span class="mr-1">{{ 'Edit content catalog' | translate }}</span>

                <span ng-hide="!catalog.title">{{ catalog.title }}</span>
                <i ng-if="!catalog.title">{{ 'Unnamed catalog' | translate }}</i>

                <button class="btn btn-xs btn-default" ng-click="renameCatalog( catalog )">
                    <b class="glyphicon glyphicon-pencil"></b>&nbsp;{{ 'Click to rename' | translate }}
                </button>
            </h3>
        </div>

        <div class="modal-body">
            <ul class="list-group">
                <li class="list-group-item" ng-repeat="(item_idx, item) in catalog.items">
                    <div class="list-group-item-heading">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="pull-left">
                                    <div class="btn-group">
                                        <button class="btn btn-xs btn-default" ng-click="reorderItem( item, catalog.items, -1 )"><b class="glyphicon glyphicon-chevron-up"></b></button>
                                        <button class="btn btn-xs btn-default" ng-click="reorderItem( item, catalog.items, +1 )"><b class="glyphicon glyphicon-chevron-down"></b></button>
                                    </div>

                                    <span>{{ item.uid }}</span>
                                </div>

                                <div class="pull-right">
                                    <button class="btn btn-xs btn-danger" ng-click="removeItem( item, catalog.items )">
                                        <b class="glyphicon glyphicon-remove"></b>&nbsp;{{ 'Click to remove' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="list-group-item-text" ng-if="item.type=='client_oeuvre'">
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="catalog-item-{{ item_idx }}-heading-input">Heading</label>
                                    <input id="catalog-item-{{ item_idx }}-heading-input" class="form-control" placeholder="Oletus: {{ catalogsService.getItemHeading( item ) }}" ng-model="item.heading">
                                </div>

                                <div class="checkbox">
                                    <label for="catalog-item-{{ item_idx }}-primary_image_hidden-input">
                                        <input type="checkbox" id="catalog-item-{{ item_idx }}-primary_image_hidden-input" ng-model="item.primary_image_hidden">
                                        {{ 'Hide catalog item primary image' | translate }}
                                    </label>
                                </div>
                            </div>

                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="catalog-item-{{ item_idx }}-description-input">Description</label>
                                    <textarea id="catalog-item-{{ item_idx }}-description-input" class="form-control" placeholder="Oletus: {{ catalogsService.getItemDescription( item ) }}" ng-model="item.description" style="resize:vertical"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row" ng-if="!item.media[0]">
                            <div class="col-xs-12">
                                <button class="btn btn-default btn-sm" ng-click="item.media=[{type:'video/vnd.youtube.yt'}]">Lisää media</button>
                            </div>
                        </div>

                        <div class="row" ng-if="item.media[0]" ng-repeat="(media_idx, media) in item.media">
                            <div class="form-group col-xs-1">
                                <div class="btn-group-vertical mt-3" ng-if="item.media.length >= 2">
                                    <button class="btn btn-xs btn-default" ng-click="reorderItem( media, item.media, -1 )"><b class="glyphicon glyphicon-chevron-up"></b></button>
                                    <button class="btn btn-xs btn-default" ng-click="reorderItem( media, item.media, +1 )"><b class="glyphicon glyphicon-chevron-down"></b></button>
                                </div>
                            </div>
                            <div class="form-group col-xs-11">
                                <label for="catalog-item-{{ item_idx }}-media-{{ media_idx }}-input">Verkko-osoite</label>
                                <div class="input-group">
                                    <input id="catalog-item-{{ item_idx }}-media-{{ media_idx }}-input" class="form-control" placeholder="Verkko-osoite" ng-model="item.media[media_idx].src">
                                    <div class="input-group-btn" uib-dropdown>
                                        <button class="btn btn-default" uib-dropdown-toggle aria-controls="catalog-item-{{ item_idx }}-media-{{ media_idx }}-type-dropdown">{{ item.media[media_idx].type }}</button>
                                        <ul dropdown-menu class="dropdown-menu" role="menu" id="catalog-item-{{ item_idx }}-media-{{ media_idx }}-type-dropdown">
                                            <li><a ng-click="item.media[media_idx].type='video/vnd.youtube.yt'">video/vnd.youtube.yt</a></li>
                                            <li><a ng-click="item.media[media_idx].type='video/*'">{{ 'Video file' | translate }}</a></li>
                                            <li><a ng-click="item.media[media_idx].type='audio/*'">{{ 'Audio file' | translate }}</a></li>
                                            <li><a ng-click="item.media[media_idx].type='image/*'">{{ 'Image file' | translate }}</a></li>
                                            <li><a ng-click="item.media[media_idx].type='iframe'">Upotettu verkkosivu</a></li> 
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="list-group-item">
                    <div class="list-group-item-heading">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="pull-left">
                                    <div class="btn-group">
                                        <button class="btn btn-sm btn-default" ng-click="addOeuvresIntoCatalog()">
                                            <b class="glyphicon glyphicon-plus"></b>&nbsp;{{ 'Add item to catalog' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="modal-footer">
            <button class="btn btn-primary" ng-click="saveChanges()">Save changes</button>
        </div>
    `;

    /**
     * @type ContentCatalog
     */
    catalog;

    static $inject = [ "$scope", "$element", "gameSceneService", "catalogsService", 'gettextCatalog', 'modalOpener', '$userAssets', '$oeuvresHandler' ];

    constructor(
        $scope,
        modalRef,
        gameSceneService,
        catalogsService,
        gettextCatalog,
        modalOpener,
        $userAssets,
        $oeuvresHandler
    ) {
        this.$scope = $scope;
        this.modalRef = elementToModalRef('modal-catalog-editor');
        this.gameSceneService = gameSceneService;
        this.catalogsService = catalogsService;
        this.gettextCatalog = gettextCatalog;
        this.modalOpener = modalOpener;
        this.$userAssets = $userAssets;
        this.$oeuvresHandler = $oeuvresHandler;

        defineThisScopeBinding( this, $scope, [ 'solveIsUnsavedChanges','arrangement', 'catalog_idx', 'catalog', 'catalog_json', 'close','modalRef', 'renameCatalog', 'reorderItem', 'pushItem', 'goToCatalogViewer', 'addOeuvresIntoCatalog', 'removeItem', 'saveChanges', ...CatalogEditorModalComponent.$inject ]);
    }

    $onInit() {
        if (!this.catalog || !this.canEdit()) {
            return this.close();
        }

        this.catalogs = this.arrangement.catalogs;

        if (!this.catalogs || !this.catalogs.length) {
            return this.close();
        }

        this.catalog_idx = this.catalogs.indexOf( this.catalog );

        if (this.catalog_idx == -1) {
            return this.close();
        }

        this.catalog = this.catalog.clone();

        this.catalog_json = JSON.stringify( this.catalog.toJSON() );
    }

    solveIsUnsavedChanges() {
        return JSON.stringify( this.catalog.toJSON() ) != this.catalog_json;
    }

    canEdit() {
        return this.arrangement && this.arrangement.$saveable && this.gameSceneService.inEditor();
    }

    saveChanges() {

        this.arrangement.catalogs[ this.catalog_idx ] = this.catalog;

        if (this.solveIsUnsavedChanges()) {
            this.catalog_json = JSON.stringify( this.catalog.toJSON() );
            window.alert( "Tallentaaksesi katalogiin tehdyt muutokset, sinun täytyy tallentaa sommitelma" );
        }

        this.goToCatalogViewer();
    }

    renameCatalog() {

        let title = this.catalog.title || this.gettextCatalog.getString( "Unnamed catalog" );

        let new_title = window.prompt( "Anna katalogin nimi", title );

        if (typeof new_title == "string") {
            this.catalog.title = new_title.trim();
        }
    }

    reorderItem( item, items, plus = 0 ) {

        let idx = items.indexOf( item );

        if (idx == -1 || plus == 0) return;

        let n_idx = idx + plus;

        if (n_idx < 0 || n_idx >= items.length) return;

        let n_item = items[ n_idx ];

        items[ idx ] = n_item;
        items[ n_idx ] = item;
    }

    removeItem( item, items ) {

        let idx = items.indexOf( item );

        if (idx == -1) return;

        if (!confirm( "Haluatko varmasti poistaa kohteen?" )) return;

        items.splice( idx, 1 );
    }

    pushItem( item, items ) {

        let idx = -1;
        for (let i in items) {
            if (items[i].uid == item.uid) {
                idx = i;
                break;
            }
        }

        if (idx != -1) return;

        items.push( item );
    }

    goToCatalogViewer() {

        this.close();

        this.catalogsService.openCatalogViewer( this.arrangement );
    }

    async addOeuvresIntoCatalog() {

        let selected_uids = this.catalog.items.filter( v => v.type == 'client_oeuvre' ).map( v => v.uid );

        let available_oeuvres = await this.$userAssets.getClientsOeuvresRaw( Object.keys( this.$oeuvresHandler.oeuvres_by_uid ) );

        let new_client_oeuvres = await this.modalOpener.openRegisteredModal( 'oeuvres-importer', selected_uids.reduce(( o, v ) => { o[v] = v; return o; }, {}), {
            oeuvres: available_oeuvres
        });

        let new_items = Object.keys( new_client_oeuvres ).map( uid => {
            try {
                return ContentCatalogClientOeuvreItem.fromJSON({ uid })
            } catch (e) {}
        });

        for (let item of new_items) {
            if (item) {
                this.pushItem( item, this.catalog.items );
            }
        }
    }

    close() {

        if (this.solveIsUnsavedChanges()) {
            
            if (!window.confirm( "Oletko varma, että haluat poistua hyväksymättä muutoksia?" )) {

                throw "aborted";
            }
        }

        this.modalRef.hide();
    }
}



export const AjsCatalogEditorModalComponent = buildUibComponentModal( "modalCatalogEditor", CatalogEditorModalComponent, {
    bindings: {
        catalog: '<',
        arrangement: '<'
    }
}, {
    size: 'lg'
});
